import React, {Component} from 'react';
import {connect} from 'react-redux';
import Layout from './layout';
import * as actions from '../../actions';
import {toJS} from "../hocs/toJs";

const parseRoles = (roles) => {
  const parsedRoles = [];
  roles.valueSeq().toArray().forEach(role => (
    parsedRoles.push({
      id: role.get('id'),
      name: role.get('name'),
    })));
  return parsedRoles;
};

class LayoutHOC extends Component {
  render(){
    return (
      <Layout
        {...this.props}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isDrawerOpen: state.general.get('isDrawerOpen'),
    token: state.loggedInPerson.get('token'),
    personRoles: state.loggedInPerson.get('roles')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    openDrawer: (payload) => {
      dispatch(actions.openDrawer(payload))
    },
    closeDrawer: (payload) => {
      dispatch(actions.closeDrawer(payload))
    },
    logout: (payload) => {
      dispatch(actions.logout(payload))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(toJS(LayoutHOC));



// WEBPACK FOOTER //
// ./src/components/layout/layoutHOC.js